/**
 * Global kill-switch for Mux video display (all public surfaces).
 *
 * OFF by default — no Mux players / reels / ambient Mux on any page.
 * Re-enable: set `VITE_MUX_DISPLAY_ENABLED=true` (or `1` / `yes` / `on`) and rebuild.
 *
 * Also honors `VITE_DISABLE_MUX_VIDEO=true` as an explicit off.
 */
export function isMuxVideoDisplayEnabled(): boolean {
  const disabled = String(
    import.meta.env.VITE_DISABLE_MUX_VIDEO ?? "",
  )
    .trim()
    .toLowerCase();
  if (disabled === "true" || disabled === "1" || disabled === "yes" || disabled === "on") {
    return false;
  }

  const raw = String(import.meta.env.VITE_MUX_DISPLAY_ENABLED ?? "")
    .trim()
    .toLowerCase();
  // Default OFF until explicitly re-enabled.
  if (!raw) return false;
  if (raw === "false" || raw === "0" || raw === "no" || raw === "off") return false;
  return raw === "true" || raw === "1" || raw === "yes" || raw === "on";
}
